type CountryFlagProps = {
  countryCode: string // ISO 3166-1 alpha-2 (ej: "CL", "AR", "US")
  size?: string // tamaño tailwind, ej: "text-2xl"
}

export function CountryFlag({ countryCode, size = "text-2xl" }: CountryFlagProps) {
  const code = countryCode?.toUpperCase() || ""
  const flag = code.replace(/./g, (char) => String.fromCodePoint(127397 + char.charCodeAt(0)))

  return <span className={`${size} mr-1 inline`}>{flag}</span>
}
